import { render, staticRenderFns } from "./FilmLifetime.vue?vue&type=template&id=9f5d228e&scoped=true"
import script from "./FilmLifetime.vue?vue&type=script&lang=ts"
export * from "./FilmLifetime.vue?vue&type=script&lang=ts"
import style0 from "./FilmLifetime.vue?vue&type=style&index=0&id=9f5d228e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f5d228e",
  null
  
)

export default component.exports